import { Button, PageHeader } from 'antd'
import React from 'react'
import { Link } from 'react-router-dom'
import JournalVoucherEntryView from '../../components/account/journal/JournalVoucherEntryView'
import AdminBreadCrumb from '../../components/layout/AdminBreadCrumb'
import TaxInvoiceEntryView from '../../components/taxinvoice/TaxInvoiceEntryView'


const TaxInvoice = () => {
  return (
    <div className='inside-main-content'>

      <AdminBreadCrumb />

        <div className="box-style" >
            <PageHeader
            ghost={false}
            onBack={() => window.history.back()}
            title="Tax Invoice Entry"
            subTitle=""
            extra={[
                <Link to={`/taxinvoice/list`} key="taxinvoice_list">
                  <Button key="taxinvoice-list-button-1" shape='round' className='custom-button-white'> List</Button>
                </Link>
            ]}
            >

            </PageHeader>


            <TaxInvoiceEntryView />

        </div>
    </div>
  )
}

export default TaxInvoice